import { useCallback, useState } from 'react'

const useSet = <T>(
  initElements: T[] = []
): [
  Readonly<Set<T>>,
  {
    add: (el: T) => Readonly<Set<T>>
    delete: (el: T) => boolean
  },
] => {
  const [set, setSet] = useState(new Set(initElements))

  const add = useCallback(
    (el: T) => {
      const clonedSet = new Set(set)
      const result = clonedSet.add(el)
      setSet(clonedSet)
      return result
    },
    [set]
  )

  const deleteCb = useCallback(
    (el: T) => {
      const clonedSet = new Set(set)
      const result = clonedSet.delete(el)
      setSet(clonedSet)
      return result
    },
    [set]
  )

  return [
    set,
    {
      add,
      delete: deleteCb,
    },
  ]
}

export default useSet
